<template>
  <div id="contract" class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont full" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">계약서</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <template v-if="contractShow == 'show'">
                <img v-for="(photo, photoIndex) in contractInfo" :key="photoIndex" :src="`data:image/png;base64,${photo}`" style="width: 100%;" />
              </template>
              <template v-if="contractShow == 'hide'">
                <div class="resultMsg error onlyMsg">
                  <p class="copy">제한된 계약서 유형입니다.</p>
                  <p class="desc">
                    계약서 문의는
                    <span class="pointC5">
                      고객센터(
                      <a href="tel:1670-0202">1670-0202</a>
                      )
                    </span>
                    로
                    <br />
                    전화문의 부탁드립니다.
                  </p>
                </div>
              </template>
              <template v-if="contractShow == ''"></template>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')">
            <span>팝업 닫기</span>
          </button>
        </div>
      </div>
    </div>
    <span class="blind focusSet last" tabindex="0"></span>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import ProgressBar from '@/views/app/comm/ProgressBar';

export default {
  name: 'OrderContractInfo',
  components: { ProgressBar },
  props: ['propsProductObj'],
  data() {
    return {
      productObj: this.propsProductObj,

      contractInfo: [],
      contractShow: '',
    };
  },
  mounted() {
    this.selectContractInfo();
  },
  methods: {
    selectContractInfo() {
      this.$refs.progress.loadingStart();
      let url = '';
      if (this.productObj.cellNum == null) {
        url = '/service/auth/contract/' + this.productObj.orderId;
      } else {
        url = '/order/nonmember/' + this.productObj.orderId + '/mobile/' + this.productObj.cellNum + '/contract';
      }

      ApiService.service('GET', url)
        .then(({ data }) => {
          console.log(data);
          this.contractInfo = data.result;

          if (this.contractInfo.length > 0) {
            this.contractShow = 'show';
          } else {
            this.contractShow = 'hide';
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
        });
    },
  },
};
</script>
